var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipseFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 336,
    height: 671,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FA6A0A",
    d: "M.5 671a335.506 335.506 0 0 0 237.234-98.266A335.508 335.508 0 0 0 336 335.5 335.502 335.502 0 0 0 .5 0v5.258a330.239 330.239 0 0 1 305.104 203.864 330.246 330.246 0 0 1-71.587 359.895A330.253 330.253 0 0 1 .5 665.742V671Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseFill);
export default __webpack_public_path__ + "static/media/ellipseFill.dc82e28c5855a4d306da10a1113898a4.svg";
export { ForwardRef as ReactComponent };